import React, { useState, useRef, useEffect } from "react";
import Dialog from "../../../../base/ui/components/web/Dialog";
import { translate } from "../../../../base/i18n/functions";
import { useTranslation } from "react-i18next";
import { hideDialog } from "../../../../base/dialog/actions";
import { connect } from "react-redux";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import PhoneIcon from "@mui/icons-material/Phone";
import { makeStyles } from "tss-react/mui";
import jwtDecode from "jwt-decode";
import {
    Box,
    TextField,
    InputLabel,
    Checkbox,
    FormGroup,
    FormControlLabel,
    InputAdornment,
} from "@mui/material";
import Swal from "sweetalert2";
import { BUTTON_TYPES } from "../../../../base/ui/constants.any";
import Button from "../../../../base/ui/components/web/Button";
const useStyles = makeStyles()((theme, lang) => {
    return {
        inviteContainer: {
            display: "grid",
            gap: "10px",
            padding: "8px",
        },
        BoxInfo: {
            display: "flex",
            flexDirection: "column",
            marginBottom: "20px",
            "& label": {
                // minWidth: "125px",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#fff",
            },
            "& input": {
                color: "#fff",
                borderBottom: "1px solid #fff",
                marginRight: "0px",
            },
        },
        OptionContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "16px",
            backgroundColor: "#37474F",
            borderRadius: "8px",
        },
        dialogdirection:{ 
                // backgroundColor: "red!important",
                direction: `${lang === "ar" ? "rtl" : "ltr"}!important`,
        },
        textInputContainer: {
            "& .MuiInputBase-root": {
                direction: `${lang === "ar" ? "rtl" : "ltr"}`,
            },
            "& .MuiInputAdornment-root": {
                marginRight: `${lang === "ar" ? "unset" : "8px"}`,
                marginLeft: `${lang === "ar" ? "8px" : "unset"}`,
            },
            "& label": {
                transformOrigin: `${lang === "ar" ? "top right" : "top left"}`,
                left: `${lang === "ar" ? "unset" : "0"}`,
                right: `${lang === "ar" ? "0" : "unset"}`,
            },
        },
    };
});

const CustomAddPeopleDialog = (props) => {
    const { t } = useTranslation();
    let lang = localStorage.getItem("language");
    const { classes } = useStyles(lang);
    const { jwt } = props.state["features/base/jwt"];
    const decodedToken = jwt && jwtDecode(jwt);
    const meetingId = decodedToken?.room;
    const eventId = decodedToken?.context.user.groupId;
    const eventURL = decodedToken?.httpsDomain ?? props?.targetProject  ;
   

    const [copied, setCopied] = useState(false);
    const [meetingLink, setMeetingLink] = useState("");
    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phoneNumber: "",
    });

    const emailRef = useRef("");
    const nameRef = useRef("");
    const phoneNumberRef = useRef("");
    const [checkboxValues, setCheckboxValues] = useState({
        autoLobby: false,
        singleAccess: false,
        enableBackground: false,
        enableRaiseHand: false,
        moderator: false,
    });

    const handleChangeCheckbox = (event) => {
        const { name, checked } = event.target;
        setCheckboxValues((prevValues) => ({
            ...prevValues,
            [name]: checked,
        }));
    };

    useEffect(() => {
        if (checkboxValues.moderator)
            setCheckboxValues((prevValues) => ({
                ...prevValues,
                ["autoLobby"]: false,
            }));
    }, [checkboxValues.moderator]);

    const validateForm = () => {
        const email = emailRef.current;
        const name = nameRef.current;
        const phoneNumber = phoneNumberRef.current;

        const errors = {
            name: "",
            email: "",
            phoneNumber: "",
        };
        if (email.trim() === "") {
            errors.email = t("dialog.participantEmailRequired");
        } else if (!isValidEmail(email)) {
            errors.email = t("dialog.participantEmailIsInvaild");
        }

        if (name.trim() === "") {
            errors.name = t("dialog.participantNameRequired");
        }
        if (phoneNumber.trim() !== "" && !isPhoneNumber(phoneNumber)) {
            errors.phoneNumber = "Oops ! please enter a valid phone number";
        
        }
        return errors;
    };

    const isValidEmail = (email) => {
        const emailPattern = /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/;
        return emailPattern.test(email.trim());
    };

    const isPhoneNumber = (phoneNumber) => {
        const phoneNumberPattern =
            /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
        return phoneNumberPattern.test(phoneNumber);
    };

    const hasErrors = (errors) => {
        return Object.values(errors).some((error) => error !== "");
    };

    const hasErrorsUpdated = (errors) => {
        const emailErrors = errors.email !== "";
        const nameErrors = errors.name !== "";
        const phoneErrors = errors.phoneNumber !== "";
        let lastStauts = emailErrors || nameErrors || phoneErrors;

        return lastStauts;
    };

    const handleSubmit = async () => {
        let formErrors = validateForm();
        setErrors(formErrors);


        if (!hasErrorsUpdated(formErrors)) {
            var eventHeader = {
                "Content-Type": "application/json",
            };

            var participantInformation = {
                active: true,
                autoLobby: checkboxValues.autoLobby,
                autoRec: false,
                fullName: nameRef.current,
                mobile: phoneNumberRef.current,
                moderator: checkboxValues.moderator,
                singleAccess: checkboxValues.singleAccess,
                email: emailRef.current,
                enableRaiseHand: checkboxValues.enableRaiseHand,
                enableBackgroundFor: decodedToken?.enableBackgroundFor,
                backgroundId: decodedToken?.context.user.backgroundId,
            };

            try {
                const result = await postParticipantInformation(
                    eventURL,
                    meetingId,
                    lang,
                    participantInformation,
                    eventHeader
                );

                // if(result.id ===)

                const participantId = result.result.id;

                await postRemindParticipant(
                    eventURL,
                    eventId,
                    participantId,
                    lang,
                    eventHeader
                );
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Participant information submitted successfully!",
                });
            } catch (error) {
                console.error("Error:", error);
            }
        }
    };

    const postParticipantInformation = async (
        eventURL,
        meetingId,
        lang,
        participantInformation,
        eventHeader
    ) => {
        const eventRequestOptions = {
            method: "POST",
            headers: eventHeader,
            body: JSON.stringify(participantInformation),
        };

        const response = await fetch(
            `${eventURL}api/participant/participants?meetingId=${meetingId}&lang=${lang}`,
            eventRequestOptions
        );

        const result = await response.json();
        return result;
    };

    const postRemindParticipant = async (
        eventURL,
        eventId,
        participantId,
        lang,
        eventHeader
    ) => {
        const remainBody = {
            tokenLang: lang,
        };

        const remaindOption = {
            method: "POST",
            headers: eventHeader,
            body: JSON.stringify(remainBody),
        };

        await fetch(
            `${eventURL}api/participant/remind-participant?eventId=${eventId}&participantId=${participantId}&lang=${lang}`,
            remaindOption
        );
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSubmit();
            // isValidUrl(urlRef.current) ? dispatch(hideDialog()) : null
            isValidEmail(emailRef.current);
            //    && !isNaN(paymentAmountRef.current) && paymentAmountRef.current > 0 ? dispatch(hideDialog()) : null
        }
    };

    const onClose = () => {
        return true;
    };

    const handleChangeEmail = (event) => {
        const { value } = event.target;
        emailRef.current = value;
        setErrors({ ...errors, email: "" });
    };

    const handleChangeName = (event) => {
        const { value } = event.target;
        nameRef.current = value;
        setErrors({ ...errors, name: "" });
    };

    const handleChangePhoneNumber = (event) => {
        const { value } = event.target;
        phoneNumberRef.current = value;
        setErrors({ ...errors, phoneNumber: "" });
    };
    const autoHide = () => {
        let validateFormErrors = validateForm(errors);
        return !(
            isValidEmail(emailRef.current) &&
            !hasErrorsUpdated(validateFormErrors)
        );
    };
useEffect(() => {
    const fetchMeetingData = async () => {
        try {
            const response = await fetch(
                `${eventURL}api/event/public/join-meeting?lang=${lang}&meetingId=${meetingId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.ok) {
                throw new Error("Failed to fetch meeting data");
            }
            const data = await response.json();
            setMeetingLink(data.result); 
        } catch (error) {
            console.error("Error fetching meeting data:", error);
        }
    };

    fetchMeetingData();
}, []); 

  const handleCopyUrl = () => {
      if (meetingLink) {
          navigator.clipboard.writeText(meetingLink);
          setCopied(true);

          setTimeout(() => {
              setCopied(false);
          }, 5000);
      } else {
          console.error("Meeting link not available");
      }
  };

  const copyButton = (
      <Box sx={{ marginRight: "15px!important", marginLeft: "15px!important" }}>
          <Button
              aria-label={t("addPeople.copyLink")}
              className={`invite-button ${copied ? "copied-button" : ""}`}
              label={
                  copied ? t("addPeople.copyLinkDone") : t("addPeople.copyLink")
              }
              onClick={handleCopyUrl}
              role="button"
              type={BUTTON_TYPES.PRIMARY}
          />
      </Box>
  );
    return (
        <Dialog
            ok={{ translationKey: "dialog.add" }}
            onCancel={onClose}
            onSubmit={handleSubmit}
            disableAutoHideOnSubmit={
                autoHide()
                // !isValidEmail(emailRef.current)
            }
            copy={{ hidden: false, copyButton: copyButton }}
            titleKey={t("addPeople.inviteMorePrompt")}
            className={classes.dialogdirection}
        >
            <Box className={classes.inviteContainer}>
                <Box className={classes.BoxInfo}>
                    <TextField
                        id="participantName"
                        label={t("settings.name")}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    sx={{ color: "#fff" }}
                                >
                                    <AccountCircle />
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                        value={nameRef.current}
                        onChange={handleChangeName}
                        error={errors.name !== ""}
                        helperText={errors.name}
                        className={classes.textInputContainer}
                    />
                </Box>

                <Box className={classes.BoxInfo}>
                    <TextField
                        id="participantEmail"
                        // label="Email:"
                        label={t("settingsView.email")}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    sx={{ color: "#fff" }}
                                >
                                    <ContactMailIcon />
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                        value={emailRef.current}
                        onChange={handleChangeEmail}
                        error={errors.email !== ""}
                        helperText={errors.email}
                        className={classes.textInputContainer}
                    />
                </Box>

                <Box className={classes.BoxInfo}>
                    <TextField
                        id="participantPhoneNumber"
                        label="Phone Number"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    sx={{ color: "#fff" }}
                                >
                                    <PhoneIcon />
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                        value={phoneNumberRef.current}
                        onChange={handleChangePhoneNumber}
                        error={errors.phoneNumber !== ""}
                        helperText={errors.phoneNumber}
                        className={classes.textInputContainer}
                    />
                </Box>
                {/* <Box className={classes.OptionContainer}>
                    <InputLabel sx={{ color: "#fff", marginBottom: "8px" }}>
                        Invitation Options:
                    </InputLabel>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxValues.moderator}
                                    onChange={handleChangeCheckbox}
                                    name="moderator"
                                />
                            }
                            label="Moderator"
                            sx={{ color: "#fff" }}
                        />
                        {checkboxValues.moderator === false && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={checkboxValues.autoLobby}
                                        onChange={handleChangeCheckbox}
                                        name="autoLobby"
                                    />
                                }
                                label="Enable waiting Room"
                                sx={{ color: "#fff" }}
                            />
                        )}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxValues.singleAccess}
                                    onChange={handleChangeCheckbox}
                                    name="singleAccess"
                                />
                            }
                            label="Enable Single Access"
                            sx={{ color: "#fff" }}
                        />
                        {decodedToken &&
                            decodedToken?.enableBackgroundFor !== 0 && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                checkboxValues.enableBackground
                                            }
                                            onChange={handleChangeCheckbox}
                                            name="enableBackground"
                                        />
                                    }
                                    label="Enable Background"
                                    sx={{ color: "#fff" }}
                                />
                            )}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxValues.enableRaiseHand}
                                    onChange={handleChangeCheckbox}
                                    name="enableRaiseHand"
                                />
                            }
                            label="Enable Raise Hand"
                            sx={{ color: "#fff" }}
                        />
                    </FormGroup>
                </Box> */}
            </Box>
        </Dialog>
    );
};

export function _mapStateToProps(state) {
    const {
        targetProject
    } = state['features/base/config'];
    return {
        state: state,
        targetProject: targetProject,
    };
}
export default translate(connect(_mapStateToProps)(CustomAddPeopleDialog));
